import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach token from localStorage as fallback (defense in depth for cookie failure)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("prumo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function extractError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Erro desconhecido";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return JSON.stringify(d);
}
